import React from 'react';
import { useIntl } from 'react-intl';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

interface Props {
  isEditMode: boolean;
}

export const GroupLoadingScreen = ({ isEditMode }: Props) => {
  const intl = useIntl();

  return (
    <LoadingWizardScreen
      text={
        isEditMode
          ? intl.formatMessage({
              id: 'predict.forecasting.saving_changes',
              defaultMessage: 'Saving changes...'
            })
          : intl.formatMessage({
              id: 'reporting.creating_group',
              defaultMessage: 'Creating group...'
            })
      }
    />
  );
};
